import React, { useContext, useState, useEffect } from 'react'
import ModalContext from '../../contexts/ModalContext'
import StockContext from '../../contexts/StockContext'
import {
  Container,
  HeaderText,
  InputRowDiv,
  InputDiv,
  InputLabel,
  ButtonsDiv,
  EditButtonDiv,
  ButtonImage,
  ButtonImageCertificate,
  ButtonText,
  MovimentButtonDiv,
  MovimentButtonImage,
  CertificateButtonDiv,
  CloseDiv,
  CloseImg,
  SwitchButton,
  ScrollDiv,
  HistorySection,
  HistoryTitle,
  HistoryTable,
  HistoryTh,
  HistoryTd,
  HistoryBadge,
} from './style'
import ApiService from '../../services/ApiService'
import { format } from 'date-fns'
import {
  FieldsToHeaders,
  fieldsToHeaders,
  StockInterface,
  formatReceivedDate,
} from '../../pages/ClientPanel/Stock/StockTable/utils'
import editPen from '../../assets/edit-pen.svg'
import activeCert from '../../assets/orders/certificate-active.svg'
import cross from '../../assets/addStockModal/cross.svg'
import doubleArrow from '../../assets/doubleArrow.svg'
import axios from '../../config/axios'
import CertificatesContext from '../../contexts/CertificatesContext'
import { Info } from 'lucide-react'
import { Button } from '../styles/modal-style'

const newModal = () => {
  const { setModalActive, setModalSection, setItIsUpdate, stockMode, setIsVariation } =
    useContext(ModalContext)
  const { stock, setStock } = useContext(StockContext)
  const { setCertificate } = useContext(CertificatesContext)
  const [activeMenu, setActiveMenu] = useState(0)
  const isFashion = stockMode === 'fashion'

  const [movements, setMovements] = useState<any[]>([])
  const [loadingMovements, setLoadingMovements] = useState<boolean>(false)

  useEffect(() => {
    const fetchHistory = async () => {
      if (stock?.id) {
        setLoadingMovements(true)
        try {
          const res = await ApiService.movements.findByStockId(stock.id)
          if (res?.data) {
            setMovements(res.data)
          }
        } catch (err) {
          console.error('Erro ao buscar histórico de movimentações:', err)
        } finally {
          setLoadingMovements(false)
        }
      }
    }
    fetchHistory()
  }, [stock?.id])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    setStock({
      ...stock,
      [name]: value,
    })
  }

  const formatQuantities = (quantities?: any[]) => {
    if (!quantities || quantities.length === 0) return 'N/A'

    return quantities.map(qty => {
      const unitName = qty.UnitOfMeasurement?.name || qty.unitOfMeasurement?.name || 'N/A'
      return `${qty.quantity} ${unitName}`.toUpperCase()
    }).join(', ')
  }

  const formatPrices = (prices?: any[]) => {
    if (!prices || prices.length === 0) return 'N/A'

    return prices.map(price => {
      const formattedPrice = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(parseFloat(price.price))
      return `${formattedPrice}/${price.UnitOfMeasurement?.name || price.unitOfMeasurement?.name || 'N/A'}`
    }).join(', ')
  }

  const normalFieldsArray: string[][] = [
    ['material', 'code'],
    ['format', 'finishing'],
    ['dimension1', 'dimension2'],
    ['quantities', 'prices'],
    ['fabrication', 'heatTreatment'],
    ['density', 'heatNumber'],
    ['receivedDate', 'originCountry'],
    ['stockStreet', 'stockLocation'],
    ['purchaseOrder', 'trackingNumber'],
    ['ncm', 'family'],
    ['supplier', 'shelf'],
    ['carrierCode', 'description'],
    ['characteristic'],
  ]

  const fashionFieldsArray: string[][] = [
    ['material', 'code'],
    ['format', 'finishing'],
    ['dimension1', 'dimension2'],
    ['quantities', 'prices'],
    ['fabrication', 'heatNumber', 'color'],
    ['receivedDate', 'originCountry'],
    ['stockStreet', 'stockLocation'],
    ['purchaseOrder', 'trackingNumber'],
    ['ncm', 'family'],
    ['supplier', 'shelf'],
    ['carrierCode', 'description'],
    ['characteristic'],
  ]

  const fieldsArray: string[][] = isFashion ? fashionFieldsArray : normalFieldsArray

  const modalEdit = () => {
    setItIsUpdate(true)
    setModalActive(true)
    setModalSection('firstCustomAdd')
  }

  const handleCreateVariation = () => {
    setIsVariation(true)
    setItIsUpdate(true)
    setStock((prev: any) => ({ ...prev, code: '', color: '' }))
    setModalActive(true)
    setModalSection('firstCustomAdd')
  }

  const newMoviment = () => {
    setItIsUpdate(true)
    setModalActive(true)
    setModalSection('modalEntryOrExit')
  }

  const certificate = () => {
    setModalSection('viewCertificate')
  }

  const handleCheckCertificate = async (certificateId: number) => {
    const certificateUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates`
    axios
      .get(`${certificateUrl}/certificate/${certificateId}`)
      .then((response) => {
        setModalActive(true)
        setModalSection('viewCertificate')
        setCertificate(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const handleSwitchActivation = async () => {
    console.log('🔄 [ACTIVATION] Iniciando alteração de status:', {
      stockId: stock.id,
      stockIdType: typeof stock.id,
      currentStatus: stock.isActivated,
      currentStatusType: typeof stock.isActivated
    })


    const newActivationStatus = !stock.isActivated

    const requestBody = {
      id: Number(stock.id),
      isActivated: Boolean(newActivationStatus),
    }

    console.log('📤 [ACTIVATION] Dados sendo enviados:', {
      requestBody,
      idType: typeof requestBody.id,
      isActivatedType: typeof requestBody.isActivated
    })

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/stock/activateStock`,
        requestBody
      )

      console.log('✅ [ACTIVATION] Resposta recebida:', {
        status: response.status,
        data: response.data
      })


      setStock(response.data.data)
      console.log(
        'Status de ativação alterado com sucesso:',
        response.data.data,
      )
      setModalActive(false)
      window.location.reload()
    } catch (error: any) {
      console.error('❌ [ACTIVATION] Erro ao mudar status de ativação:', {
        error,
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      })
      alert('Erro ao mudar status de ativação.')
    }
  }

  return (
    <Container>
      <HeaderText>{stock.description}</HeaderText>
      <CloseDiv onClick={() => setModalActive(false)}>
        <CloseImg src={cross} alt='Close tab' />
      </CloseDiv>
      <ScrollDiv>
        {fieldsArray.map((inputRow, rowIndex) => (
          <InputRowDiv key={rowIndex}>
            {inputRow.map((stockField: string, colIndex) => (
              <InputDiv key={colIndex}>
                <InputLabel htmlFor={stockField}>
                  {fieldsToHeaders[stockField as keyof FieldsToHeaders] || (stockField === 'prices' ? 'Preços' : stockField)}:
                </InputLabel>
                <p className='ml-2'>
                  {stockField === 'receivedDate'
                    ? formatReceivedDate(stock[stockField as keyof StockInterface] as string)
                    : stockField === 'prices'
                    ? formatPrices(stock.prices)
                    : stockField === 'quantities'
                    ? formatQuantities(stock.quantities)
                    : (stock[stockField as keyof StockInterface] || 'N/A')}
                </p>
              </InputDiv>
            ))}
          </InputRowDiv>
        ))}

        {(stock.invoiceId || stock.externalInvoiceUrl || stock.certificateId || stock.externalCertificateUrl || (stock.attachments && stock.attachments.length > 0)) && (
          <HistorySection style={{ marginTop: '2.5vh' }}>
            <HistoryTitle>Documentos e Anexos</HistoryTitle>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1vh', marginTop: '1vh' }}>
              {(stock.invoiceId || stock.externalInvoiceUrl) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5vw' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '0.9vw' }}>Nota Fiscal:</span>
                  {stock.externalInvoiceUrl ? (
                    <a
                      href={stock.externalInvoiceUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#0090D3', textDecoration: 'underline', fontSize: '0.9vw' }}
                    >
                      Visualizar Nota Fiscal Externa
                    </a>
                  ) : (
                    <span style={{ fontSize: '0.9vw' }}>
                      NF #{stock.invoiceId} (Interna do Sistema)
                    </span>
                  )}
                </div>
              )}

              {(stock.certificateId || stock.externalCertificateUrl) && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5vw' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '0.9vw' }}>Certificado:</span>
                  {stock.externalCertificateUrl ? (
                    <a
                      href={stock.externalCertificateUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#0090D3', textDecoration: 'underline', fontSize: '0.9vw' }}
                    >
                      Visualizar Certificado Externo
                    </a>
                  ) : (
                    <button
                      onClick={() => handleCheckCertificate(Number(stock.certificateId))}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#0090D3',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        padding: 0,
                        fontSize: '0.9vw',
                        textAlign: 'left'
                      }}
                    >
                      Visualizar Certificado Interno #{stock.certificateId}
                    </button>
                  )}
                </div>
              )}

              {stock.attachments && stock.attachments.length > 0 && (
                <div style={{ marginTop: '1vh' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '0.9vw', display: 'block', marginBottom: '0.5vh' }}>Anexos Gerais:</span>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.8vw' }}>
                    {stock.attachments.filter((att: any) => {
                      const fileUrl = att?.fileUrl || att?.filePath || (typeof att === 'string' ? att : '');
                      const title = att?.title || att?.name || att?.originalName || '';
                      const isSpecialAttachment = title === 'Nota Fiscal Externa' || title === 'Certificado Externo';
                      return fileUrl && !fileUrl.includes('[object Object]') && !fileUrl.startsWith('[object ') && !isSpecialAttachment;
                    }).map((att: any, idx: number) => {
                      const fileUrl = att.fileUrl || att.filePath || att
                      const title = att.title || att.name || att.originalName || fileUrl?.split('/').pop() || `Anexo-${idx + 1}`
                      return (
                        <a
                          key={att.id || idx}
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.3vw',
                            background: '#F3F4F6',
                            padding: '0.5vh 0.8vw',
                            borderRadius: '1vw',
                            color: '#374151',
                            textDecoration: 'none',
                            fontSize: '0.8vw',
                            border: '1px solid #E5E7EB'
                          }}
                        >
                          {title}
                        </a>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>
          </HistorySection>
        )}

        <HistorySection>
          <HistoryTitle>Histórico de Movimentações</HistoryTitle>
          {loadingMovements ? (
            <p style={{ color: '#6b7280', fontSize: '0.9vw' }}>Carregando histórico...</p>
          ) : movements.length === 0 ? (
            <p style={{ color: '#6b7280', fontSize: '0.9vw' }}>Nenhuma movimentação registrada.</p>
          ) : (
            <HistoryTable>
              <thead>
                <tr>
                  <HistoryTh>Data</HistoryTh>
                  <HistoryTh>Tipo</HistoryTh>
                  <HistoryTh>Qtd</HistoryTh>
                  <HistoryTh>Novo Peso</HistoryTh>
                  <HistoryTh>Novo Comp.</HistoryTh>
                  <HistoryTh>Operação/Pedido</HistoryTh>
                  <HistoryTh>Usuário</HistoryTh>
                </tr>
              </thead>
              <tbody>
                {movements.map((mv) => {
                  const isEntry = mv.ploomesOrderId === 0;
                  const isExit = mv.ploomesOrderId === 1;
                  const type = isEntry ? 'entry' : isExit ? 'exit' : 'order';
                  const label = isEntry ? 'Entrada' : isExit ? 'Saída' : 'Pedido';
                  return (
                    <tr
                      key={mv.id}
                      title={
                        (mv.User?.name || mv.User?.email) && mv.createdAt
                          ? `Atualizado por ${mv.User.name || mv.User.email} em ${
                            format(new Date(mv.createdAt), 'dd/MM/yyyy - HH:mm')}h${
                            mv.observation ? `\nObservação: ${mv.observation}` : ''
                          }`
                          : undefined
                      }
                    >
                      <HistoryTd>{format(new Date(mv.createdAt), 'dd/MM/yyyy HH:mm')}</HistoryTd>
                      <HistoryTd>
                        <HistoryBadge type={type}>{label}</HistoryBadge>
                      </HistoryTd>
                      <HistoryTd>
                        {mv.quantity != null
                          ? Number.isInteger(Number(mv.quantity))
                            ? Number(mv.quantity).toString()
                            : Number(mv.quantity).toFixed(2)
                          : '-'}
                      </HistoryTd>
                      <HistoryTd>{mv.newTotalWeight != null ? `${mv.newTotalWeight.toFixed(2)} kg` : '-'}</HistoryTd>
                      <HistoryTd>{mv.newLengthInMm != null ? `${mv.newLengthInMm.toFixed(0)} mm` : '-'}</HistoryTd>
                      <HistoryTd>{mv.orderName || '-'}</HistoryTd>
                      <HistoryTd>{mv.User?.name || mv.User?.email || '-'}</HistoryTd>
                    </tr>
                  );
                })}
              </tbody>
            </HistoryTable>
          )}
        </HistorySection>
      </ScrollDiv>
      <ButtonsDiv>
        <Button
          onClick={handleSwitchActivation}
          style={{
            backgroundColor: 'transparent',
            color: stock.isActivated ? '#F87171' : '#10B981',
            border: stock.isActivated ? '1px solid #F87171' : '1px solid #10B981'
          }}
        >
          {stock.isActivated ? 'Inativar' : 'Ativar'}
        </Button>

        {isFashion && (
          <MovimentButtonDiv
            onClick={handleCreateVariation}
            disabled={!stock.isActivated}
            style={{
              backgroundColor: 'transparent',
              color: '#8B5CF6',
              border: '1px solid #8B5CF6'
            }}
          >
            <ButtonText>Criar Variação</ButtonText>
          </MovimentButtonDiv>
        )}

        <MovimentButtonDiv
          onClick={newMoviment}
          disabled={!stock.isActivated}
          style={{
            backgroundColor: 'transparent',
            color: '#10B981',
            border: '1px solid #10B981'
          }}
        >
          <MovimentButtonImage src={doubleArrow} />
          <ButtonText>Novo movimento</ButtonText>
        </MovimentButtonDiv>

        <EditButtonDiv
          onClick={modalEdit}
          disabled={!stock.isActivated}
          style={{
            backgroundColor: 'transparent',
            color: '#6b7280',
            border: '1px solid #d1d5db'
          }}
        >
          <ButtonImage src={editPen} style={{ filter: 'grayscale(1)' }} />
          <ButtonText>Editar</ButtonText>
        </EditButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default newModal
